import React from "react";
import PropTypes from "prop-types";
import { ImagePropTypes } from "./Image";
import { ButtonStyledPropTypes } from "../../modernized/Buttons/ButtonStyled";

const Video = () => {
    return <br />;
};

export const VideoPropTypes = {
    source: PropTypes.string.isRequired,
    mediaSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    thumbnail: PropTypes.shape(ImagePropTypes).isRequired,
    play_button: PropTypes.shape(ButtonStyledPropTypes).isRequired
};
Video.propTypes = VideoPropTypes;
Video.defaultProps = {};
export default Video;
